import { ResponsivePie } from '@nivo/pie';
import React from 'react';
import { MoneyListChart } from '~/models/money/MoneyList';

export const ChartPie: React.FC<{ chartData: MoneyListChart[] }> = ({ chartData }) => {
    return (
        <ResponsivePie
            data={chartData.filter(item => item.value > 0)}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
            legends={[
                {
                    anchor: 'bottom-left',
                    direction: 'row',
                    justify: false,
                    translateX: -65,
                    translateY: 56,
                    itemsSpacing: 0,
                    itemWidth: 130,
                    itemHeight: 30,
                    itemTextColor: '#999',
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: '#000',
                            },
                        },
                    ],
                },
            ]}
        />
    );
};
